import { SearchOrganizations } from "./SearchOrganizations";

export const SectionWithSearchOrganizations = () => {
  return (
    <div className="mb-3 flex items-center gap-3">
      <div className="grow"></div>
      <SearchOrganizations extendSearch />
    </div>
  );
};
